import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { showPaymentsApi } from "../../redux/payments/paymentApiCalls";
import DataTableOrder from "./DataTableOrder";
import TableTypeButtons from "./TableTypeButtons";
import { FaChevronCircleLeft } from "react-icons/fa";
import { useNavigate } from "react-router";
import { getMedecinTypesApi } from "../../redux/medecinType/medecinTypeApiCalls";

const ShowOrdreTable = () => {
  const dispatch: any = useDispatch();

  useEffect(() => {
    const fetchAPIs = async () => {
      await dispatch(getMedecinTypesApi());
      await dispatch(showPaymentsApi());
    };
    fetchAPIs();
  }, [dispatch]);

  const navigate = useNavigate();

  return (
    <div>
      <div className="flex justify-start gap-2">
        <FaChevronCircleLeft
          style={{ fontSize: "30px" }}
          className="text-main"
          onClick={() => navigate("/")}
        />
      </div>
      <TableTypeButtons />
      <DataTableOrder />
    </div>
  );
};

export default ShowOrdreTable;
